module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[44]531.0f46319.woff2";